"use strict";

module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Addresses",
        "advertising": "Advertising",
        "afisha": "Afisha",
        "all": "All services",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Apps",
        "audience": "Audience",
        "auto": "Auto",
        "autoru": "auto.ru",
        "avia": "Flights",
        "aziada": "Азиада",
        "ba": "Bayan",
        "backapv": "Партнер Я.Карт",
        "balance": "Balance",
        "bar": "Bar",
        "bar-ie": "Бар для ИЕ",
        "bar-ie9": "Бар для ИЕ9",
        "bayan": "Баннеры Яндекса",
        "blogs": "Blogs",
        "books": "Books",
        "browser": "Browser",
        "calendar": "Calendar",
        "captcha": "ой...",
        "catalogwdgt": "Каталог виджетов",
        "chrome": "Хром с поиском Яндекса",
        "city": "Cities",
        "cityday": "City Day",
        "clickhouse": "ClickHouse",
        "collection": "Collection",
        "company": "Company",
        "contest": "Contest",
        "delivery": "Delivery",
        "desktop": "Персональный поиск",
        "direct": "Direct",
        "direct.market": "Market",
        "disk": "Disk",
        "display": "Display",
        "ege": "Russian Grade School State Exams",
        "expert": "Эксперт",
        "feedback": "Contact us",
        "feedback2": "Contact us",
        "ff": "ФФ с поиском Яндекса",
        "fotki": "Photos",
        "fresh": "Recent",
        "games": "Games",
        "geocontext": "Геоконтекст",
        "goroda": "Города",
        "help": "Help",
        "i": "Мои сервисы",
        "ie": "ИЕ с поиском Яндекса",
        "images": "Images",
        "images-com": "Images",
        "interests": "Interests",
        "internet": "Интернет",
        "kassa": "Payment Solution",
        "keyboard": "Клавиатура",
        "kraski": "Краски",
        "kuda": "Where",
        "large": "Яндекс для слабовидящих",
        "legal": "Legal documents",
        "lenta": "Feeds",
        "libra": "Library",
        "literacy": "Неделя борьбы за грамотность",
        "local": "Local Network",
        "lost": "Незабудки",
        "love": "День взаимного тяготения — 13 августа",
        "mail": "Mail",
        "maps": "Maps",
        "maps-wiki": "Народная карта",
        "market": "Market",
        "market.advertising": "Market",
        "master": "Yandex.Master",
        "metrika": "Metrica",
        "metro": "Метро",
        "mobile": "Mobile",
        "moikrug": "Moi Krug",
        "money": "Money",
        "museums": "Дни исторического и культурного наследия",
        "music": "Music",
        "music-partner": "Музыка: статистика",
        "nahodki": "My Findings",
        "nano": "Nano",
        "newhire": "Newhire",
        "news": "News",
        "notifications": "Notifications panel",
        "oauth": "OAuth",
        "online": "Online",
        "openid": "OpenID",
        "opera": "Opera Software",
        "opinion": "Цитаты",
        "partners": "Advertising Network",
        "partnersearch": "Поиск для партнеров",
        "passport": "Passport",
        "pdd": "Mail for Domains",
        "peoplesearch": "People search",
        "perevod": "Translate",
        "probki": "Пробки",
        "pulse": "блоги: пульс",
        "punto": "Punto switcher",
        "pvo": "Ask",
        "rabota": "Jobs",
        "radar": "Radar",
        "ramazan": "",
        "rasp": "Timetables",
        "realty": "Недвижимость",
        "referats": "Рефераты",
        "rk": "Есть вопросы?",
        "root": "Yandex.Olympiad for Unix administrators",
        "school": "Школа",
        "search": "Web",
        "server": "Server",
        "shtrafi": "Штрафы",
        "site": "Site search",
        "slovari": "Dictionaries",
        "so": "Самооборона",
        "social": "Социализм",
        "soft": "Programs",
        "sport": "Sport",
        "sprav": "Directory",
        "start": "Стартовая страница",
        "stat": "Статистика",
        "subs": "Subscriptions",
        "taxi": "Taxi",
        "telephony": "Телефония",
        "terms": "Разговорник",
        "tests": "Тесты и опросы",
        "tickets": "Tickets",
        "time": "Yandex.Time",
        "toloka": "Yandex.Toloka",
        "toster": "Тосты",
        "translate": "Translate",
        "tune": "Tune",
        "tv": "TV",
        "uslugi": "Services",
        "video": "Video",
        "video-com": "Video",
        "vno": "ZNO",
        "wdgt": "Widgets",
        "weather": "Weather",
        "webmaster": "Webmaster",
        "webmaster-api": "Webmaster API",
        "widgets": "Widgets",
        "wordstat": "Statistics",
        "wow": "Ya.ru",
        "www": "Web",
        "xmlsearch": "XML",
        "yaca": "Catalog",
        "yamb": "Media Banners",
        "zakladki": "Bookmarks"
    }
};